import axios, { CreateAxiosDefaults } from 'axios';
import { ResourceConfig } from '@repo/core/resources';
import { setRequestInterceptor, setResponseInterceptor } from '@repo/core/security';
import { instrumentAxios } from '@repo/telemetry-config/interceptor';

const config: CreateAxiosDefaults = {
  adapter: 'fetch',
  baseURL: ResourceConfig.serverBase,
  headers: { 'Content-Type': 'application/json' }
};

export const api = axios.create(config);

setRequestInterceptor(api);
setResponseInterceptor(api);
instrumentAxios(api);
